import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useModalA11y } from '../hooks/useModalA11y';

const ConfirmDialog = ({
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  danger = false,
  busy = false,
  onConfirm,
  onCancel
}) => {
  const containerRef = useModalA11y(onCancel);

  return (
    <div className="fixed inset-0 z-[60] bg-black/75 backdrop-blur-sm flex items-end sm:items-center sm:justify-center sm:p-5" role="alertdialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
      <button className="absolute inset-0 w-full" onClick={onCancel} aria-label="Cancelar" />
      <div ref={containerRef} tabIndex={-1} className="relative w-full sm:max-w-sm surface-raised rounded-b-none sm:rounded-b-2xl p-5 sm:p-6 animate-slideUp">
        <div className={`w-11 h-11 rounded-2xl grid place-items-center mb-4 ${danger ? 'bg-red-500/10 text-red-300' : 'bg-lime-400/10 text-lime-300'}`}>
          <AlertTriangle className="w-5 h-5" />
        </div>
        <h2 id="confirm-dialog-title" className="text-xl font-extrabold">{title}</h2>
        {description && <p className="text-sm text-slate-400 mt-2 leading-relaxed">{description}</p>}
        <div className="grid grid-cols-2 gap-3 mt-6">
          <button onClick={onCancel} disabled={busy} className="btn-secondary py-3 text-sm">{cancelLabel}</button>
          <button onClick={onConfirm} disabled={busy} className={busy ? 'btn-secondary py-3 text-sm' : `${danger ? 'btn-danger' : 'btn-primary'} py-3 text-sm`}>{busy ? 'Aguarde...' : confirmLabel}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
